import {useEffect} from "react";
import { useSelector, useDispatch } from "react-redux";
import {
  nextPage,
  previousPage,
  selectExpertiseQuestions,
  questionAnswered,
  selectPage,
  resetPage,
  selectExpertiseComplete
} from "../features/expertise/expertiseSlice.js";
import expertiseIcon from "../assets/Navigation/nav_icon_expertise_green.png";
import SideNav from "../components/SideNav";
import PageTitle from "../components/PageTitle";
import { Link } from "react-router-dom";
import SlideOut from "../components/SlideOut.js";
import halfStat from '../assets/Popups/popup_industry_stat_1-2.png'
import { ArrowBackIos, ArrowForwardIos } from "@mui/icons-material";
import { Button, Container } from "@mui/material";

const Expertise = () => {
  const page = useSelector(selectPage);
  const expertiseQuestions = useSelector(selectExpertiseQuestions)
  const dispatch = useDispatch();
  const section = {
    title: "Expertise Availability",
    icon: expertiseIcon,
    pages: [1, 2, 3],
  };
  const isComplete = useSelector(selectExpertiseComplete)
  useEffect(
    ()=>!isComplete ? dispatch(resetPage()):null,[]
  )
  const calcWellAverage = () => {
    switch (expertiseQuestions[1].answer) {
      case '<10':
        return 5;
      case '10-50':
        return 30;
      case '50-100':
        return 75;
      case '100-1000':
        return 550;
      case '1000+':
        return 1000;
      default:
        return 0
                }
              }

  const calcYield = (engineers) =>{
    let wells = calcWellAverage()
    let wellYield = wells/engineers
    if(wellYield < 1 || wellYield > 100) {
      return 1
    } else if ( wellYield >= 1 && wellYield < 10){
      return 2
    } else if ( wellYield >= 10 && wellYield < 25){
      return 3
    } else if (wellYield >= 25 && wellYield <= 100){
      return 2
    }
  }

  const personnelChallenges = {
    title: 'Overcome Field Personnel Challenges',
    copy: 'Using Roxar 2600 Multiphase Flow Meter (MPFM) can help your operation overcome field personnel challenges with:',
    bullets: [<li>Remote access to actionable data</li>, <li>Increased coverage/wells per operator (increased productivity & efficiency)</li>, <li>Reduced HSE risk with less field visits (especially with inexperienced personnel)</li>]
  }

  const increaseExperience = {
    title:'Increase Experience Pool',
    copy:'Using Roxar 2600 Multiphase Flow Meter (MPFM) can help your operation leverage expertise with the ability to collaborate on issues. While also increasing experience pool through remote analysis, and shared problem solving through Emerson supported analysis.',
    stat:{
      copy:'Over half of surveyed field engineers have less than 2 years of experience.*',
      graphic: halfStat
    }
  }

  return (
    <Container className="content_container" maxWidth='lg'>
    <div className="roxar_content">
      <div className="main_content">
        <PageTitle section={section} currentPage={page} />
        <div className="page_contents">
          {page === 1 && (
            <div className="challenges">
              <div>
                <h1>Production Challenges</h1>
                <ul>
                  <li>
                  Limited availability of field workforce 
                  </li>
                  <li>
                   Lack of experience (technical and safety)
                  </li>
                </ul>
              </div>
              <div className="solution_copy">
                <p>
                Is managing too many wells stretching your field engineers thin? Roxar 2600 Multiphase Flow Meter (MPFM) increases the number of wells each engineer can cover – increasing productivity and driving down costs.                </p>
                <Button className="forward_button production_button" onClick={() => dispatch(nextPage())}>Learn How</Button>
              </div>
            </div>
          )}
          {page === 2 && (
            <div className="questions">
              <div>
                  <h3 className="question">Q: How many wells can one field engineer visit per day?</h3>
                  <div className="answers">
                      <Button className={`answer ${expertiseQuestions[0].answer=='1'?'active_answer':null}`} onClick={(e)=> dispatch(questionAnswered({question:0,answer:'1', score:1, max: 4}))}> 1 </Button>
                      <Button className={`answer ${expertiseQuestions[0].answer=='2-5'?'active_answer':null}`} onClick={(e)=> dispatch(questionAnswered({question:0,answer:'2-5', score:2, max: 4}))}> 2-5</Button>
                      <Button className={`answer ${expertiseQuestions[0].answer=='6-10'?'active_answer':null}`} onClick={(e)=> dispatch(questionAnswered({question:0,answer:'6-10', score:3, max: 4}))}> 6-10</Button>
                      <Button className={`answer ${expertiseQuestions[0].answer=='11+'?'active_answer':null}`} onClick={(e)=> dispatch(questionAnswered({question:0,answer:'11+', score:4, max: 4}))}> 11+</Button>
                  </div>
              </div>
              <div>
                  <h3 className="question">Q: How many wells do you operate currently?</h3>
                  <div className="answers">
                      <Button className={`answer ${expertiseQuestions[1].answer=='<10'?'active_answer':null}`} onClick={(e)=> dispatch(questionAnswered({question:1,answer:'<10', score:1, max: 5}))}> &lt;10</Button>
                      <Button className={`answer ${expertiseQuestions[1].answer=='10-50'?'active_answer':null}`} onClick={(e)=> dispatch(questionAnswered({question:1,answer:'10-50', score:2, max: 5}))}> 10-50 </Button>
                      <Button className={`answer ${expertiseQuestions[1].answer=='50-100'?'active_answer':null}`} onClick={(e)=> dispatch(questionAnswered({question:1,answer:'50-100', score:3, max: 5}))}> 50-100</Button>
                      <Button className={`answer ${expertiseQuestions[1].answer=='100-1000'?'active_answer':null}`} onClick={(e)=> dispatch(questionAnswered({question:1,answer:'100-1000', score:4, max: 5}))}> 100-1000</Button>
                      <Button className={`answer ${expertiseQuestions[1].answer=='1000+'?'active_answer':null}`} onClick={(e)=> dispatch(questionAnswered({question:1,answer:'1000+', score:5, max: 5}))}> 1000+ </Button>
                  </div>
              </div>
              <div>
                  <h3 className="question">Q: Are you able to access and control your well site remotely today?</h3>
                  <div className="answers">
                      <Button className={`answer ${expertiseQuestions[2].answer=='Yes'?'active_answer':null}`} onClick={(e)=> dispatch(questionAnswered({question:2,answer:'Yes', score:4, max: 4}))}> Yes</Button>
                      <Button className={`answer ${expertiseQuestions[2].answer=='No'?'active_answer':null}`} onClick={(e)=> dispatch(questionAnswered({question:2,answer:'No', score:2, max: 4}))}> No </Button>
                      
                  </div>
              </div>
              <div className="page_nav">
              <Button className="prev_button" onClick={() => dispatch(previousPage())}><ArrowBackIos /><span>Previous</span></Button>
                  <Button className="next_button" onClick={() => dispatch(nextPage())}><span>Next</span><ArrowForwardIos /></Button>
              </div>
            </div>
          )}
          {page === 3 && (
              <div className="questions">
              <div>
                  <h3 className="question">Q: What is the average experience (years) of your field engineers?</h3>
                  <div className="answers">
                  <Button className={`answer ${expertiseQuestions[3].answer=='0-6 months'?'active_answer':null}`} onClick={(e)=> dispatch(questionAnswered({question:3,answer:'0-6 months', score:1, max: 3}))}> 0-6 months</Button>
                  <Button className={`answer ${expertiseQuestions[3].answer=='6 months-2 years'?'active_answer':null}`} onClick={(e)=> dispatch(questionAnswered({question:3,answer:'6 months-2 years', score:2, max: 3}))}> 6 months-2 years</Button>
                  <Button className={`answer ${expertiseQuestions[3].answer=='2-5 years'?'active_answer':null}`} onClick={(e)=> dispatch(questionAnswered({question:3,answer:'2-5 years', score:3, max: 3}))}> 2-5 years</Button>
                  <Button className={`answer ${expertiseQuestions[3].answer=='5-15 years'?'active_answer':null}`} onClick={(e)=> dispatch(questionAnswered({question:3,answer:'5-15 years', score:2, max: 3}))}> 5-15 years</Button>   
                  <Button className={`answer ${expertiseQuestions[3].answer=='>15 years'?'active_answer':null}`} onClick={(e)=> dispatch(questionAnswered({question:3,answer:'>15 years', score:1, max: 3}))}> &gt;15 years</Button>   
                  </div>
              </div>
              <div>
                  <h3 className="question">Q: Is the average experience of your field engineers increasing or decreasing?</h3>
                  <div className="answers">
                  <Button className={`answer ${expertiseQuestions[4].answer=='Increasing'?'active_answer':null}`} onClick={(e)=> dispatch(questionAnswered({question:4,answer:'Increasing', score:['5-15 YEARS','>15 YEARS'].includes(expertiseQuestions[3].answer)?2:4, max: 4}))}> Increasing</Button>
                  <Button className={`answer ${expertiseQuestions[4].answer=='Decreasing'?'active_answer':null}`} onClick={(e)=> dispatch(questionAnswered({question:4,answer:'Decreasing', score:['5-15 YEARS','>15 YEARS'].includes(expertiseQuestions[3].answer)?4:2, max: 4}))}> Decreasing</Button>  
                  </div>
              </div>
              <div>
                  <h3 className="question">Q: How many field engineers do you have?</h3>
                  <div className="answers short_answers">
                  <Button className={`answer ${expertiseQuestions[5].answer=='0 (fully outsourced)'?'active_answer':null}`} onClick={(e)=> dispatch(questionAnswered({question:5,answer:'0 (fully outsourced)', score:calcYield(1), max:3 }))}>  0 (fully outsourced)</Button>
                  <Button className={`answer ${expertiseQuestions[5].answer=='1-10'?'active_answer':null}`} onClick={(e)=> dispatch(questionAnswered({question:5,answer:'1-10', score:calcYield(5), max:3 }))}> 1-10</Button>
                  <Button className={`answer ${expertiseQuestions[5].answer=='11-50'?'active_answer':null}`} onClick={(e)=> dispatch(questionAnswered({question:5,answer:'11-50', score:calcYield(30), max:3 }))}> 11-50</Button>
                  <Button className={`answer ${expertiseQuestions[5].answer=='50-100'?'active_answer':null}`} onClick={(e)=> dispatch(questionAnswered({question:5,answer:'50-100', score:calcYield(75), max:3 }))}>50-100</Button>   
                  <Button className={`answer ${expertiseQuestions[5].answer=='100+'?'active_answer':null}`} onClick={(e)=> dispatch(questionAnswered({question:5,answer:'100+', score:calcYield(500), max:3 }))}>100+</Button>   
                  </div>
              </div>
              
              <div className="page_nav">
              <Button className="prev_button" onClick={() => dispatch(previousPage())}><ArrowBackIos /><span>Previous</span></Button>
              <Button className="next_button" component={ Link } to={'/cost'}><span>Next</span><ArrowForwardIos /></Button>
              </div>
              <div>
                  <Button component={Link} to='/results' className="next_button view_results">View Section Results</Button>
              </div>
            </div>
          )}
        </div>
      </div>
      {page === 2 && (
          <SlideOut title={personnelChallenges.title} copy={personnelChallenges.copy}  bullets={personnelChallenges.bullets}/>
          )}
          {page === 3 && (
            <SlideOut title={increaseExperience.title} copy={increaseExperience.copy} stat={increaseExperience.stat}/>
            )}
      <SideNav />
    </div>
    </Container>
  );
};

export default Expertise;